/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "payments": {
        "nested": {
          "capture": {
            "nested": {
              "CaptureError": {
                "values": {
                  "DEFAULT_ENUM_DO_NOT_USE": 0,
                  "INVALID_CREATOR": 1,
                  "INVALID_STATE": 2,
                  "OVERCAPTURE": 3,
                  "TRANSACTION_LIMIT": 4,
                  "RECORD_NOT_FOUND": 5,
                  "OTHER": 6,
                  "INVALID_AMOUNT": 7,
                  "CURRENCY_MISMATCH": 8
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.payments?.nested?.capture?.nested?.CaptureError) {
  $root.addJSON(jsonData);
}

/**
 * The reason a capture was declined according to the gateway.
 *
 * SOURCE CaptureError @ squareup/payments/capture.proto at 9:1
 */
export const CaptureError = $root.lookupEnum('squareup.payments.capture.CaptureError').values;